import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getHelpTopicForPath } from '../lib/help-registry';

const HelpContext = createContext();

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return context;
};

export const HelpProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentTopicId, setCurrentTopicId] = useState('general-introduction');
  const location = useLocation();

  // Automatically update topic based on route, but don't force open
  useEffect(() => {
    const topic = getHelpTopicForPath(location.pathname);
    setCurrentTopicId(topic);
  }, [location.pathname]);

  const openHelp = (topicId) => {
    if (topicId) setCurrentTopicId(topicId);
    setIsOpen(true);
  };

  const closeHelp = () => setIsOpen(false);
  const toggleHelp = () => setIsOpen(prev => !prev);

  const value = {
    isOpen,
    currentTopicId,
    setCurrentTopicId,
    openHelp,
    closeHelp,
    toggleHelp
  };

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
};
